import gql from 'graphql-tag';

const GET_NEXXEN_SEGMENT_SETS = gql`
  query getNexxenSegmentSets($advertiserId: ID!, $isReusable: Boolean, $offset: Int, $limit: Int) {
    nexxenSegmentSets(advertiserId: $advertiserId, isReusable: $isReusable, offset: $offset, limit: $limit) {
      queryTotal
      data {
        id
        name
        description
        status
        advertiserId
        isReusable
        cpmCost
        percentCost
      }
    }
  }
`;

export default GET_NEXXEN_SEGMENT_SETS;
